import React from "react";

const CreatorIcon = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 21a8 8 0 0 0-16 0" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <polygon points="12 2 13 4.5 15.5 4.5 13.5 6 14 8.5 12 7 10 8.5 10.5 6 8.5 4.5 11 4.5" stroke="currentColor" strokeWidth={1.5} />
  </svg>
);

export default CreatorIcon;
